export default __webpack_public_path__ + "static/media/man-new.9a3e1fb3.jpg";